import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const immersiveLabs = defineConnector({
  identifier: "immersiveLabs",
  name: "Immersive Labs",
  tagLine: "Cybersecurity skills and training",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.immersivelabs\\.online/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Immersive Labs API credentials",
      items: [
        {
          kind: "markdown",
          content: `1. In Immersive Labs, go to **Settings › API**
2. Generate an access key and secret token
3. Copy both values`,
        },
      ],
    },
    {
      title: "Enter your credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.immersivelabs.online/v1/people?page_size=1",
  },
});
